(function () {
  // Header: mobile menu + search panel
  var header = document.querySelector('.site-header');
  if (header) {
    var menuBtn = header.querySelector('.menu-btn');
    if (menuBtn) menuBtn.addEventListener('click', function () {
      var open = header.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    header.querySelectorAll('.sub-toggle').forEach(function (b) {
      b.addEventListener('click', function () {
        var li = b.parentNode, open = li.classList.toggle('open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    var searchBtn = header.querySelector('.search-btn');
    var panel = header.querySelector('.search-panel');
    if (searchBtn && panel) searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      panel.hidden = !panel.hidden;
      searchBtn.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      if (!panel.hidden) panel.querySelector('input').focus();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (header.classList.contains('open')) { header.classList.remove('open'); menuBtn && menuBtn.setAttribute('aria-expanded', 'false'); }
      if (panel && !panel.hidden) { panel.hidden = true; searchBtn && searchBtn.setAttribute('aria-expanded', 'false'); }
    });
  }

  // Mood rail tabs: each tab shows one panel
  document.querySelectorAll('[data-moods]').forEach(function (root) {
    var tabs = root.querySelectorAll('.tabs button');
    var panels = root.querySelectorAll('.rail-panel');
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      });
    });
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Cart: auto-submit on quantity change
  document.querySelectorAll('form[data-cart]').forEach(function (f) {
    f.addEventListener('change', function (e) { if (e.target.matches('.qty input')) f.requestSubmit ? f.requestSubmit() : f.submit(); });
    var age = f.querySelector('[data-age-ok]');
    if (!age) return;
    var msg = f.querySelector('[data-age-msg]');
    var express = f.querySelector('[data-age-express]');
    function sync() {
      if (express) express.hidden = !age.checked;
      if (age.checked && msg) msg.hidden = true;
    }
    age.addEventListener('change', function () {
      sync();
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Age confirmed 18+': age.checked ? 'Yes' : '' } })
      }).catch(function () {});
    });
    sync();
    f.addEventListener('submit', function (e) {
      var s = e.submitter;
      if (s && s.name === 'checkout' && !age.checked) {
        e.preventDefault();
        if (msg) msg.hidden = false;
        age.focus();
      }
    });
  });

  // Product: gallery + variant picker
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var mainImg = root.querySelector('.main-img img');
    root.querySelectorAll('.thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = b.dataset.src; mainImg.srcset = b.dataset.srcset || ''; mainImg.alt = b.dataset.alt || '';
        root.querySelectorAll('.thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });

    var json = root.querySelector('script[data-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var addBtn = root.querySelector('[data-add]');
    var priceEl = root.querySelector('[data-price]');
    var form = root.querySelector('form[action*="/cart/add"]');

    function selected() {
      var opts = [];
      root.querySelectorAll('.option').forEach(function (fs) {
        var c = fs.querySelector('input:checked'); opts.push(c ? c.value : null);
      });
      return opts;
    }
    function update() {
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) { if (!addBtn) return; addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailable; return; }
      idInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.dataset.unit = v.price;
        addBtn.textContent = v.available ? addBtn.dataset.add : addBtn.dataset.soldout;
        sum();
        packsFor(v.price);
        if (packs && !v.available) packs.hidden = true;
      }
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (v.image && mainImg) { mainImg.src = v.image; mainImg.srcset = ''; }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    // Basket button shows the total for the chosen quantity
    var qtyInput = root.querySelector('.qty input');
    function sum() {
      if (!addBtn || addBtn.disabled || !addBtn.dataset.unit) return;
      var n = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var total = new Intl.NumberFormat('en-GB', { style: 'currency', currency: addBtn.dataset.cur || 'GBP' }).format(addBtn.dataset.unit * n / 100);
      addBtn.textContent = addBtn.dataset.add + ' · ' + total;
    }
    if (qtyInput) { qtyInput.addEventListener('change', sum); qtyInput.addEventListener('input', sum); }

    // Bundle cards: pick 1 or the bundle size, recalculated for the chosen variant
    var packs = root.querySelector('[data-packs]');
    var money = function (p) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: (addBtn && addBtn.dataset.cur) || 'GBP' }).format(p / 100); };
    function packsFor(price) {
      if (!packs) return;
      var t1 = +packs.dataset.t1, t3 = +packs.dataset.t3, goal = t1, pct = +packs.dataset.p1;
      if (price >= t1) { goal = t3; pct = +packs.dataset.p3; }
      var n = Math.max(2, Math.ceil(goal / price));
      packs.hidden = !price || price >= t3 || n > 4;
      var full = price * n;
      packs.querySelector('[data-pk-n]').value = n;
      packs.querySelector('[data-pk-title]').textContent = 'Bundle of ' + n;
      packs.querySelector('[data-pk-now]').textContent = money(full - Math.floor(full * pct / 100));
      packs.querySelector('[data-pk-was]').textContent = money(full);
      packs.querySelector('[data-pk-save]').textContent = 'Save ' + pct + '%';
      packs.querySelector('[data-pk-one]').textContent = money(price);
      syncPacks();
    }
    function syncPacks() {
      if (!packs || !qtyInput) return;
      var q = qtyInput.value;
      packs.querySelectorAll('input[name="pack"]').forEach(function (r) { r.checked = r.value === q; });
    }
    if (packs) {
      packs.addEventListener('change', function (e) {
        if (!e.target.matches('input[name="pack"]') || !qtyInput) return;
        qtyInput.value = e.target.value;
        sum();
      });
      if (qtyInput) { qtyInput.addEventListener('change', syncPacks); qtyInput.addEventListener('input', syncPacks); }
    }
    root.querySelectorAll('.option input').forEach(function (i) { i.addEventListener('change', update); });
  });

  // Pick list on the product page: + / − per flavour and per extra, one basket button for all
  document.querySelectorAll('[data-pick]').forEach(function (pk) {
    var form = pk.closest('form'), btn = form && form.querySelector('[data-add]');
    if (!btn) return;
    var D = pk.dataset, msg = pk.querySelector('[data-pick-msg]'), qIn = form.querySelector('[data-pick-qty]'), idIn = form.querySelector('input[name="id"]');
    var express = form.querySelector('.shopify-payment-button');
    var gbp = function (p) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: btn.dataset.cur || 'GBP' }).format(p / 100); };
    var rows = pk.querySelectorAll('.pk-row[data-v]');
    function paint(li) {
      var q = +li.dataset.q, o = li.querySelector('output');
      if (!o) return;
      o.textContent = q; li.classList.toggle('on', q > 0);
    }
    function upd() {
      var n = 0, tot = 0, lines = 0, first = null;
      rows.forEach(function (li) { var q = +li.dataset.q; if (!q) return; n += q; tot += q * li.dataset.p; lines++; if (!first) first = li; });
      var mine = qIn ? 0 : Math.max(1, +(form.querySelector('.qty input') || { value: 1 }).value || 1) * (+btn.dataset.unit || 0);
      if (qIn) {
        btn.disabled = n === 0;
        btn.textContent = n ? (n === 1 ? btn.dataset.add : 'Add ' + n + ' to basket') + ' · ' + gbp(tot) : 'Pick at least one';
        if (first) { idIn.value = first.dataset.v; qIn.value = first.dataset.q; }
        if (express) express.hidden = lines !== 1;
      } else if (n) {
        btn.textContent = 'Add all to basket · ' + gbp(tot + mine);
        if (express) express.hidden = true;
      } else if (express) express.hidden = false;
      if (!D.tiers || !msg) return;
      var all = (+D.cart || 0) + tot + mine, t;
      if (all < +D.t1) t = '<b>' + gbp(D.t1 - all) + '</b> more to save ' + D.p1 + '%.';
      else if (all < +D.fr) t = D.p1 + '% off unlocked. <b>' + gbp(D.fr - all) + '</b> more for free UK delivery.';
      else if (all < +D.t3) t = D.p1 + '% off and free UK delivery. <b>' + gbp(D.t3 - all) + '</b> more to save ' + D.p3 + '%.';
      else t = 'You have the full ' + D.p3 + '% off and free UK delivery.';
      msg.innerHTML = t; msg.hidden = false;
    }
    rows.forEach(paint);

    // Quick view: click a product in the list → pop-up with photos, price, description and + / −
    var qv = pk.querySelector('[data-qvbox]'), qvRow = null, qvPrev = null, cache = {};
    if (qv) document.body.appendChild(qv);
    var clean = function (html) {
      var d = new DOMParser().parseFromString(html || '', 'text/html');
      d.querySelectorAll('script,style,iframe,object,embed,form,link,meta,input,button,textarea,select').forEach(function (n) { n.remove(); });
      d.querySelectorAll('*').forEach(function (n) {
        Array.prototype.slice.call(n.attributes).forEach(function (a) { var k = a.name.toLowerCase(); if (k.indexOf('on') === 0 || k === 'style' || ((k === 'href' || k === 'src') && /^\s*javascript:/i.test(a.value))) n.removeAttribute(a.name); });
      });
      return d.body.innerHTML;
    };
    function qvSync() { if (!qvRow) return; var q = +qvRow.dataset.q; qv.querySelector('[data-qv-q] output').textContent = q; qv.querySelector('[data-qv-q]').classList.toggle('on', q > 0); }
    function qvClose() {
      if (qv.hidden) return;
      qv.classList.remove('in'); document.documentElement.style.overflow = '';
      setTimeout(function () { qv.hidden = true; }, 250);
      if (qvPrev) qvPrev.focus({ preventScroll: true });
      qvRow = null;
    }
    function qvFill(p) {
      var gal = qv.querySelector('[data-qv-gal]'); gal.textContent = '';
      (p.images || []).slice(0, 8).forEach(function (src) {
        var im = document.createElement('img'); src = src.indexOf('//') === 0 ? 'https:' + src : src;
        im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800'; im.alt = p.title; im.loading = 'lazy'; gal.appendChild(im);
      });
      gal.hidden = !gal.children.length;
      qv.querySelector('[data-qv-t]').textContent = p.title;
      qv.querySelector('[data-qv-p]').textContent = gbp(+qvRow.dataset.p);
      qv.querySelector('[data-qv-d]').innerHTML = clean(p.description);
      qv.querySelector('[data-qv-a]').href = p.url || ('/products/' + p.handle);
    }
    function qvOpen(li, from) {
      if (!qv) return;
      qvRow = li; qvPrev = from;
      qv.querySelector('[data-qv-t]').textContent = li.querySelector('.pk-t b').textContent;
      qv.querySelector('[data-qv-p]').textContent = gbp(+li.dataset.p);
      qv.querySelector('[data-qv-d]').textContent = 'Loading…'; qv.querySelector('[data-qv-gal]').textContent = '';
      qvSync();
      qv.hidden = false; document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { qv.classList.add('in'); });
      qv.querySelector('.qv-x').focus({ preventScroll: true });
      qv.querySelector('.qv-dlg').scrollTop = 0;
      var h = li.dataset.h;
      (cache[h] ? Promise.resolve(cache[h]) : fetch('/products/' + h + '.js').then(function (r) { return r.json(); }))
        .then(function (p) { cache[h] = p; if (qvRow === li) qvFill(p); })
        .catch(function () { qv.querySelector('[data-qv-d]').textContent = ''; });
    }
    if (qv) {
      qv.addEventListener('click', function (e) {
        if (e.target.closest('[data-qv-x]')) return qvClose();
        var b = e.target.closest('[data-qd]');
        if (b && qvRow) { qvRow.dataset.q = Math.max(0, +qvRow.dataset.q + +b.dataset.qd); paint(qvRow); upd(); qvSync(); }
      });
      document.addEventListener('keydown', function (e) {
        if (qv.hidden) return;
        if (e.key === 'Escape') return qvClose();
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(qv.querySelectorAll('button,a[href]'), function (x) { return x.getClientRects().length; });
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
    }

    pk.addEventListener('click', function (e) {
      var a = e.target.closest('[data-qv]');
      if (a && qv) { e.preventDefault(); return qvOpen(a.closest('.pk-row'), a); }
      var b = e.target.closest('.pk-b'); if (!b) return;
      var li = b.closest('.pk-row'); li.dataset.q = Math.max(0, +li.dataset.q + +b.dataset.d); paint(li); upd();
    });
    var qty = form.querySelector('.qty input'); if (qty) { qty.addEventListener('input', upd); qty.addEventListener('change', upd); }
    form.querySelectorAll('.option input').forEach(function (i) { i.addEventListener('change', function () { setTimeout(upd, 0); }); });
    form.addEventListener('submit', function (e) {
      var items = [];
      if (!qIn && idIn) items.push({ id: +idIn.value, quantity: Math.max(1, +(qty && qty.value) || 1) });
      rows.forEach(function (li) { if (+li.dataset.q) items.push({ id: +li.dataset.v, quantity: +li.dataset.q }); });
      if (!qIn && items.length === 1) return;
      e.preventDefault();
      if (!items.length) return;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw r; window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; if (msg) { msg.hidden = false; msg.textContent = 'Something went wrong. Please try again.'; } upd(); });
    });
    upd();
  });

  // "Full description" link opens the accordion
  document.querySelectorAll('[data-open-acc]').forEach(function (a) {
    a.addEventListener('click', function () { var d = document.querySelector(a.getAttribute('href')); if (d) d.open = true; });
  });

  // Bundle pop-up: once, after a delay, not until the age check is done; closing hides it for 7 days
  var bpop = document.querySelector('[data-bpop]');
  if (bpop) {
    var KEY = 'eroticon_bpop', last = +(localStorage.getItem(KEY) || 0);
    var hide = function () { localStorage.setItem(KEY, Date.now()); bpop.classList.remove('in'); setTimeout(function () { bpop.hidden = true; }, 400); };
    if (Date.now() - last > 7 * 864e5) {
      var tries = 0;
      var show = function () {
        var cb = document.getElementById('shopify-pc__banner');
        var waiting = document.cookie.indexOf('eroticon_age=1') < 0 || (cb && cb.getClientRects().length > 0 && getComputedStyle(cb).visibility !== 'hidden');
        if (waiting && tries++ < 40) return setTimeout(show, 3000);
        if (waiting) return;
        bpop.hidden = false; requestAnimationFrame(function () { bpop.classList.add('in'); });
      };
      setTimeout(show, (+bpop.dataset.delay || 8) * 1000);
    }
    bpop.querySelector('[data-bpop-x]').addEventListener('click', hide);
    bpop.querySelector('[data-bpop-go]').addEventListener('click', function () { hide(); openBox(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !bpop.hidden && !(bbox && bbox.classList.contains('in'))) hide(); });
  }

  // Build-your-box: pick products with + / −, the ladder counts the basket plus the box
  var bbox = document.querySelector('[data-bbox]');
  function openBox() {
    if (!bbox) return;
    bbox.prev = document.activeElement;
    bbox.hidden = false; document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { bbox.classList.add('in'); });
    bbox.querySelector('[data-bbox-x].bbox-x').focus({ preventScroll: true });
    loadBox();
  }
  function closeBox() {
    bbox.classList.remove('in'); document.documentElement.style.overflow = '';
    setTimeout(function () { bbox.hidden = true; }, 300);
    if (bbox.prev && bbox.prev.focus) bbox.prev.focus({ preventScroll: true });
  }
  document.querySelectorAll('[data-bbox-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openBox(); }); });
  if (bbox) {
    var D = bbox.dataset, gbp = function (p) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(p / 100); };
    var ul = bbox.querySelector('[data-bbox-items]'), loaded = false, inCart = +D.cart || 0;
    var el = function (t, c, x) { var e = document.createElement(t); if (c) e.className = c; if (x != null) e.textContent = x; return e; };
    var cents = function (p) { return Math.round(parseFloat(p) * 100); };
    var rows = function () { return ul.querySelectorAll('li[data-h]'); };
    var priceOf = function (li) { var s = li.querySelector('select'); return s ? +s.options[s.selectedIndex].dataset.p : +li.dataset.p; };
    var idOf = function (li) { var s = li.querySelector('select'); return s ? +s.value : +li.dataset.v; };
    function row(p) {
      var vs = p.variants.filter(function (v) { return v.available; });
      var li = el('li'); li.dataset.h = p.handle; li.dataset.q = 0; li.dataset.v = vs[0].id; li.dataset.p = cents(vs[0].price);
      var a = el('a', 'bbox-img'); a.href = '/products/' + p.handle; a.setAttribute('aria-label', p.title);
      if (p.images && p.images[0]) { var im = el('img'); var s = p.images[0].src; im.src = s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=140'; im.alt = ''; im.width = 64; im.height = 64; im.loading = 'lazy'; a.appendChild(im); }
      li.appendChild(a);
      var info = el('div', 'bbox-info'); var nm = el('a', 'bbox-name', p.title); nm.href = '/products/' + p.handle; info.appendChild(nm);
      if (vs.length > 1) {
        var sel = el('select'); sel.setAttribute('aria-label', 'Option for ' + p.title);
        vs.forEach(function (v) { var o = el('option', null, v.title + ' · ' + gbp(cents(v.price))); o.value = v.id; o.dataset.p = cents(v.price); sel.appendChild(o); });
        info.appendChild(sel);
      } else info.appendChild(el('span', 'bbox-price', gbp(cents(vs[0].price))));
      li.appendChild(info);
      var q = el('div', 'bbox-q');
      var m = el('button', 'bbox-b', '−'); m.type = 'button'; m.dataset.d = -1; m.hidden = true; m.setAttribute('aria-label', 'Remove one ' + p.title);
      var n = el('span', 'bbox-n', '0'); n.hidden = true;
      var pl = el('button', 'bbox-b plus', '+'); pl.type = 'button'; pl.dataset.d = 1; pl.setAttribute('aria-label', 'Add ' + p.title);
      q.appendChild(m); q.appendChild(n); q.appendChild(pl); li.appendChild(q);
      return li;
    }
    function setQ(li, n) {
      li.dataset.q = n; var q = li.querySelector('.bbox-q');
      q.children[0].hidden = q.children[1].hidden = n === 0; q.children[1].textContent = n;
      li.classList.toggle('on', n > 0); upd();
    }
    function upd() {
      var n = 0, box = 0, slots = bbox.querySelector('[data-bbox-slots]'); slots.textContent = '';
      rows().forEach(function (li) {
        var q = +li.dataset.q; if (!q) return; n += q; box += q * priceOf(li);
        for (var k = 0; k < q && slots.children.length < 8; k++) {
          var b = el('button', 'bbox-slot'); b.type = 'button'; b.setAttribute('aria-label', 'Remove one ' + li.querySelector('.bbox-name').textContent);
          var im = li.querySelector('img'); if (im) { var c = el('img'); c.src = im.src; c.alt = ''; b.appendChild(c); }
          b.addEventListener('click', function () { setQ(li, Math.max(0, +li.dataset.q - 1)); });
          slots.appendChild(b);
        }
      });
      var t1 = +D.t1, fr = +D.fr, t3 = +D.t3, tot = inCart + box, pct = tot >= t3 ? +D.p3 : tot >= t1 ? +D.p1 : 0, msg;
      if (tot < t1) msg = '<b>' + gbp(t1 - tot) + '</b> more to save ' + D.p1 + '%.';
      else if (tot < fr) msg = D.p1 + '% off unlocked. <b>' + gbp(fr - tot) + '</b> more for free UK delivery.';
      else if (tot < t3) msg = D.p1 + '% off and free UK delivery. <b>' + gbp(t3 - tot) + '</b> more to save ' + D.p3 + '%.';
      else msg = 'You have the full ' + D.p3 + '% off and free UK delivery.';
      if (inCart && n) msg += ' Counts what is already in your basket.';
      bbox.querySelector('[data-bbox-msg]').innerHTML = msg;
      bbox.querySelector('[data-bbox-fill]').style.width = Math.min(100, tot / t3 * 100) + '%';
      bbox.querySelector('[data-bbox-count]').textContent = n + (n === 1 ? ' item' : ' items');
      var tEl = bbox.querySelector('[data-bbox-total]'), off = Math.floor(box * pct / 100);
      tEl.innerHTML = pct && n ? '<s>' + gbp(box) + '</s> ' + gbp(box - off) : gbp(box);
      var add = bbox.querySelector('[data-bbox-add]'); add.disabled = n === 0;
      add.textContent = n ? 'Add ' + n + (n === 1 ? ' item' : ' items') + ' to basket' : 'Pick something to start';
    }
    function loadBox() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { inCart = c.items_subtotal_price || 0; upd(); }).catch(function () {});
      if (loaded) return upd(); loaded = true; upd();
      fetch(D.src).then(function (r) { return r.json(); }).then(function (d) {
        var ps = (d.products || []).filter(function (p) { return p.variants.some(function (v) { return v.available; }); });
        var me = D.product && ps.filter(function (p) { return p.handle === D.product; })[0];
        var go = function (list) {
          var f = document.createDocumentFragment(); list.forEach(function (p) { f.appendChild(row(p)); }); ul.appendChild(f);
          bbox.querySelector('[data-bbox-load]').hidden = true;
        };
        if (D.product && !me) {
          fetch('/products/' + D.product + '.js').then(function (r) { return r.json(); }).then(function (p) {
            if (p.variants.some(function (v) { return v.available; })) {
              p.variants.forEach(function (v) { v.price = (v.price / 100).toFixed(2); });
              p.images = (p.images || []).map(function (s) { return { src: s.indexOf('//') === 0 ? 'https:' + s : s }; });
              ps.unshift(p);
            }
            go(ps);
          }).catch(function () { go(ps); });
        } else { if (me) { ps.splice(ps.indexOf(me), 1); ps.unshift(me); } go(ps); }
      }).catch(function () { bbox.querySelector('[data-bbox-load]').textContent = 'Could not load the products. Please try again.'; });
    }
    bbox.addEventListener('click', function (e) {
      if (e.target.closest('[data-bbox-x]')) return closeBox();
      var b = e.target.closest('.bbox-b'); if (b) { var li = b.closest('li'); return setQ(li, Math.max(0, +li.dataset.q + +b.dataset.d)); }
      var add = e.target.closest('[data-bbox-add]');
      if (add) {
        var items = []; rows().forEach(function (li) { if (+li.dataset.q) items.push({ id: idOf(li), quantity: +li.dataset.q }); });
        if (!items.length) return;
        add.disabled = true; add.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw r; window.location.href = '/cart'; })
          .catch(function () { bbox.querySelector('[data-bbox-msg]').textContent = 'Something went wrong. Please try again.'; add.disabled = false; add.textContent = 'Add to basket'; });
      }
    });
    bbox.addEventListener('change', function (e) { if (e.target.matches('select')) upd(); });
    document.addEventListener('keydown', function (e) {
      if (!bbox.classList.contains('in')) return;
      if (e.key === 'Escape') return closeBox();
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(bbox.querySelectorAll('button:not([disabled]),a[href],select'), function (x) { return x.getClientRects().length; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }

  // Trust tab on the side
  var ttab = document.querySelector('[data-ttab]');
  if (ttab) {
    var tb = ttab.querySelector('.ttab-btn'), tc = ttab.querySelector('.ttab-card');
    var setT = function (open) { tc.hidden = !open; tb.setAttribute('aria-expanded', open ? 'true' : 'false'); if (open) tc.querySelector('[data-ttab-x]').focus(); };
    tb.addEventListener('click', function () { setT(tc.hidden); });
    tc.querySelector('[data-ttab-x]').addEventListener('click', function () { setT(false); tb.focus(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !tc.hidden) { setT(false); tb.focus(); } });
    document.addEventListener('click', function (e) { if (!tc.hidden && !ttab.contains(e.target)) setT(false); });
  }

  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia('(hover: none)').matches;

  // Video hero: the header floats over it until the page scrolls
  var vhero = document.querySelector('[data-vhero]');
  if (vhero && header && vhero.closest('.shopify-section') === document.querySelector('main .shopify-section')) {
    var setH = function () { document.documentElement.style.setProperty('--hh', header.offsetHeight + 'px'); };
    setH(); window.addEventListener('resize', setH);
    header.classList.add('over');
    var onScroll = function () { header.classList.toggle('solid', window.scrollY > 40); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    var hv = vhero.querySelector('video');
    if (hv && still) { hv.pause(); hv.removeAttribute('autoplay'); }
  }

  // Video chapters: play on hover, or while in view on touch screens
  document.querySelectorAll('[data-chapters] .ch').forEach(function (c) {
    var v = c.querySelector('video');
    if (!v || still) return;
    var play = function () {
      if (!v.src) v.src = v.dataset.src;
      c.classList.add('on');
      var p = v.play(); if (p) p.catch(function () {});
    };
    var stop = function () { c.classList.remove('on'); v.pause(); };
    if (touch && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? play() : stop(); }); }, { threshold: 0.6 }).observe(c);
    } else {
      c.addEventListener('mouseenter', play);
      c.addEventListener('mouseleave', stop);
      c.addEventListener('focus', play);
      c.addEventListener('blur', stop);
    }
  });

  // Pleasure finder: three taps, then the matching collection with a price filter
  document.querySelectorAll('[data-finder]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-finder-map]').textContent);
    var q = root.querySelector('[data-q]'), steps = root.querySelector('[data-steps]');
    var picks = [];
    var lists = [data.who, data.mood, data.budget];
    function draw() {
      var i = picks.length;
      q.textContent = data.q[i];
      steps.innerHTML = '';
      lists[i].forEach(function (label, n) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'chip'; b.textContent = label.trim();
        b.addEventListener('click', function () { b.classList.add('on'); picks.push(n); setTimeout(next, 220); });
        steps.appendChild(b);
      });
    }
    function next() {
      if (picks.length < 3) return draw();
      q.textContent = data.done;
      var url = data.urls[picks[0]][picks[1]];
      window.location.href = url + (url.indexOf('?') < 0 ? '?' : '&') + data.prices[picks[2]];
    }
    draw();
  });
})();
